import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  // firestoreConnect,
  useFirestoreConnect,
  isEmpty,
  isLoaded,
  withFirestore,
} from 'react-redux-firebase';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import EmptyState from '../../components/EmptyState';
import FullScreenLoader from '../../components/FullScreenLoader';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import Snackbar from '../../components/Snackbar';
import MainTitle from '../../components/MainTitle';
import MainCard from '../../components/MainCard';
import Popup from '../../components/Modal/PopUp';
import { connect } from 'react-redux';
import { storage, firestore, getPagingOpinions } from '../../configs/environments/firebase/firebaseApp';
import { deleteOpinion, updateOpinionsPage } from '../../store/actions/UserAction';
import { Pagination } from '@material-ui/lab';
import * as ROUTES from '../../routes';

const opinionsImg = '/img/empty-state/opinions.svg';

const useStyles = makeStyles({
  container: {
    display: 'flex'
  },
  containerOpinions: {
    width: 680
  },
  instructions: {
    width: 248, 
    marginLeft: 71,
  },
  '@media (max-width:1023px)':{
    container: {
      flexWrap: 'wrap-reverse'
    },
    containerOpinions: {
      width: '100%',
    },
    instructions: {
      width: '100%', 
      marginLeft: 0,
    },
  },
  mainTitle: {
    '@media (max-width:768px)':{
      padding: '0 24px'
    }
  }
});

const Opinions = (props) => {

  const [arrayItems, setArrayItems]= useState([])
  const [page, setPage] = useState();
  const [totalPage, setTotalPage] = useState();

  const { uid, deleteOpinion, opinionsLaw, updateOpinionsPage, membershipType, role } = props;
  const [ docs, setDocs ] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    fetchMyAPI();
  }, []);

  async function fetchMyAPI() {
    try {
      let opinions = opinionsLaw;
      let total = opinions.totalPages;
      setArrayItems(opinions.data)
      setTotalPage(total);
    } catch (error) {
      throw error;
    }
  }

  console.log('arrayItems', arrayItems);
  console.log('opinionsLaw', opinionsLaw);
  console.log('totalPage', totalPage);
  console.log('page', page);
  
  const handleChangePage = async (event, value) => {
    try {
      updateOpinionsPage(uid, value);
      let opinions = opinionsLaw
      console.log('2');
      setArrayItems(opinions.data)
    } catch (error) {
      throw error;
    }
  };

  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [opinionWillDelete, setOpinionWillDelete] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const handleChangeChecked = (uidOpinion, uidAuth) => (event) => {
    const ref = firestore.collection('opinions').doc(uidAuth).collection('opinion').doc(uidOpinion)
    const { value, checked } = event.target;
    ref
      .update({ show: checked })
      .then(() => {
        setFeedbackMessage({
          open: true,
          message: 'Opinión cambiada',
          variant: 'success',
        });
      })
      .catch((error) => {
        setFeedbackMessage({
          open: true,
          message: 'No se pudo actualizar! Ha ocurrido un error',
          variant: 'error',
        });
      });
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleOpenModalDelete = (id) => {
    setOpenModalDelete(true);
    setOpinionWillDelete(id);
  };

  const confirmDelete = async (event) => {
    event.preventDefault();
    setOpenModalDelete(false);
    // setArrayItems(opinionsLaw)
    deleteOpinion(opinionWillDelete, opinionsLaw, uid, totalPage).then(async (res) => {
      // setArrayItems(opinionsLaw.data)
      setFeedbackMessage({
        open: true,
        message: 'La opinión se eliminó exitosamente',
        variant: 'success',
      });
      setArrayItems(opinionsLaw.data)
    });
  };

  // Esto lo conectaremos al modal
  // /membresias-abogados

  // Esto talvez ayude a buscar un emptystate para la cuarta tab de pagos
  // formas de pago 

  return (
    <>
      {membershipType === 'Free' ?
        (
          <EmptyState
            title={<span>¡No te quedes sin clientes!</span>}
            subtitle={<span>Obtén opiniones de clientes satisfechos y publícalas en tu perfil<br/>
              para que más personas adquieran tus servicios. Solo disponible con<br/>
              una membresía Premium o Premium Plus </span>
            }
            img={opinionsImg}
            direction={ROUTES.MEMBERSHIPS_LAWYERS}
            handleClick={() => console.log('Ver las membresías')}
            callToAction="Ver membresías"
          />
        ) :
      arrayItems && !arrayItems.length ? (
        !isLoaded(arrayItems) ? (
          <FullScreenLoader loading={true} />
        ) : (
          <EmptyState
            title="Invita a tus clientes a generar un comentario."
            subtitle="La generación de buenas opiniones te ayudara a estar mejor posicionado en los resultados de busqueda."
            img={opinionsImg}
            handleClick={() => props.history.push(ROUTES.MESSAGES)}
            callToAction="Ir a mis contactos"
          />
        )
      ) : (
        <>
          <div style={{ display: 'flex', flexFlow: 'column', width: '100%' }}>
            <div style={{margin:'0 auto', maxWidth: '100%'}}>
              <div className={classes.mainTitle}>
                <MainTitle
                  title="Opiniones"
                  subtitle="Los elementos que seleccione serán los que aparecerán publicados en su perfil."
                />
              </div>
              
              <br />
              <br />
                <div className={classes.container}>
                <div className={classes.containerOpinions}>
                  {arrayItems && arrayItems.length > 0 ? (
                    arrayItems.map((item, index) => {
                      if (!item.visible) {
                        return null
                      }
                      return (
                        <MainCard
                          item={item}
                          featured={item.hidden}
                          handleChangeChecked={handleChangeChecked(
                            item.uid, uid
                          )}
                          id={index}
                          handleClickDelete={()=>{
                            handleOpenModalDelete(item.uid)
                          }}
                        />
                      )
                    }
                  )
                  ) : (
                    <p>2</p>
                  )}
                  {totalPage && totalPage <= 1 ?
                    null : 
                    totalPage === 0 || totalPage === undefined ? 
                    null :
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
                      <Pagination
                        color="primary"
                        count={totalPage}
                        page={page}
                        onChange={handleChangePage}
                      />
                    </div>
                  }
                </div>
                <div className={classes.instructions}>
                  <Card>
                    <CardHeader
                      title={
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#10587f',
                          }}
                        >
                          Instrucciones
                        </Typography>
                      }
                      style={{
                        borderBottom: 'solid 0.5px #e7e7e7',
                        paddingBottom: 6,
                        paddingTop: 8,
                      }}
                    />
                    <CardContent style={{ padding: '8px 24px' }}>
                      <Typography style={{ fontSize: 14 }}>
                        Después de revisar tus opiniones, selecciona la casilla
                        ubicada a la izquierda, para marcarla como opinión
                        importante.
                        <br /> Las opiniones seleccionadas aparecerán publicadas
                        en tu perfil. <br />
                        <br />
                        Al terminar, guarda los cambios para terminar el proceso.
                      </Typography>
                    </CardContent>
                  </Card>
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>

          <Popup
            open={openModalDelete}
            handleClose={() => setOpenModalDelete(false)}
            title="¿Deseas eliminar esta opinion?"
            subtitle="Si decides eliminar esta opinión, ya no se podrá recuperar y dejará de estar visible en tu perfil."
            primaryButton={true}
            primaryButtonVariant="primarySolidOutlined"
            primaryButtonText="Sí, Eliminar"
            primaryFunction={confirmDelete}
            secondaryButton={true}
            secondaryButtonVariant="primary"
          />
        </>
      )}

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={80}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  role: state.authClient.role,
  opinionsLaw: state.authClient.opinionsLaw,
  membershipType: state.authClient.membership.type,
});

const mapDispatchToProps = (dispatch) => ({
  deleteOpinion: (id, arrayOpinion, uidAuth, page) => dispatch(deleteOpinion(id, arrayOpinion, uidAuth, page)),
  updateOpinionsPage:(uid, page) => dispatch(updateOpinionsPage(uid,page))
});

export default connect(mapStateToProps, mapDispatchToProps)(Opinions);
